export default __webpack_public_path__ + "static/media/complete.f0967a4d.svg";